export const themeColors = {
  paper: "#ffffff",
  darkPaper: "#0D0D0D",

  // Primary
  // primaryLight: "#fff8e1",
  // primaryMain: "#fe9d0b",
  // primaryDark: "#fd6c0c",
  // primary200: "#ffde82",
  // primary800: "#fe8c0b",

  primaryLight: "#548ca3",
  primaryMain: "#2A708C",
  primaryDark: "#1d4e62",
  primary200: "#e890bb",
  primary100: "#f0bbd6",
  primary50: "#ffecf4",

  // Secondary
  secondaryLight: "#fce8e7",
  secondaryMain: "#ee3518",
  secondaryDark: "#c71a07",
  secondary200: "#ffa690",
  secondary800: "#e02c13",

  // secondaryLight: "#ff9d45",
  // secondaryMain: "#f15a29",
  // secondaryDark: "#b72500",
  // secondary200: "#fdae95",
  // secondary100: "#fdcebf",
  // secondary50: "#faeae8",

  // Success
  successLight: "#dcf7de", //#81c784, #ccecce
  successMain: "#2e7d32",
  successDark: "#205723", //#1b5e20
  success200: "#a5d6a7",
  success800: "#859303",

  // Error
  // errorMain: "#d32f2f",
  // errorLight: "#ef5350",
  // errorDark: "#c62828",

  errorLight: "#ef9a9a",
  errorMain: "#f44336",
  errorDark: "#c62828",

  // orange
  orangeLight: "#fbe9e7",
  orangeMain: "#ffab91",
  orangeDark: "#d84315",

  // warning
  warningLight: "#fff8e1",
  warningMain: "#ffe57f",
  warningDark: "#ffc107",

  // Grey
  grey50: "#fafafa",
  grey100: "#f2f2f2",
  grey200: "#ebe6e7",
  grey300: "#d1d5dc",
  grey400: "#bdbdbd",
  grey500: "#6a7282",
  grey600: "#757575",
  grey700: "#616161",
  grey800: "#0D0D0D",
  grey900: "#212121",
};
